<template>
  <div class="w-full flex flex-col min-w-0">
    <div v-for="i in skeletonCount" :key="`hook-skeleton-${i}`"
    class="w-full flex items-center gap-3 p-2 min-w-0" style="height: 52px;">
      <div class="skeleton h-9 rounded-md" style="width: 67px;" />
      <div class="skeleton w-8 h-8 rounded-md" />
      <div class="skeleton flex-grow h-9 rounded-md" />
      <div class="skeleton h-6 rounded-md" style="width: 104px;" />
      <div class="skeleton h-8 rounded-md" style="width: 110px;" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HooksListLoadingState',
  props: {
    skeletonCount: {
      type: Number,
      default: 25
    }
  }
}
</script>